/**
 * Admin card to activate a ReturnGo portal on Global-e (return-update) for a selected store.
 */
import { observer } from 'mobx-react-lite';
import React from 'react';
import ListLayout from '../../../components/layouts/list-layout/list-layout';
import { Button } from '../../../components/inputs/button/button';
import Card from '../../../components/layouts/card/card';
import FontBody1 from '../../../components/fonts/font-body1/font-body1';
import { FONT_COLOR, FONT_VARIANT } from '../../../components/fonts/font-props';
import ShopsSelector from '../../../components/shops-selector/shops-selector';
import { FormFieldLine } from '../../../components/form-field-line/form-field-line';
import { Input } from '../../../components/inputs/input/input';
import merchantActivationStore from './stores/merchant-activation-store';
import { isSet } from '../../../models/model-types-methods';
import './migrate-global-e-merchants.scss';
import {IShop} from "../../../models/User";

const ActivateGlobaleStoreCard: React.FC = observer(() => {
    const store = merchantActivationStore;
    const selected = store.portal;

    return (
        <Card
            isExpanded={true}
            toolbar={{
                title: (
                    <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        Activate Global-e Store
                    </FontBody1>
                ),
            }}
        >
            <ListLayout>
                <FormFieldLine label="Select a Global-e portal to activate">
                    <ShopsSelector
                        value={store.portal ? [store.portal] : [] as IShop[]}
                        onChange={(shops: IShop[]) => store.setPortal(shops[0])}
                        disabled={store.isProcessing || isSet(selected)}
                        includeSecondaryPortals
                    />
                </FormFieldLine>

                <FormFieldLine label="Merchant ID">
                    <Input value={store.merchantIdDisplay} disabled />
                </FormFieldLine>

                <FormFieldLine label="Global-e Environment">
                    <Input value={store.globalEEnvDisplay} disabled />
                </FormFieldLine>

                <FormFieldLine label="Portal URL">
                    <Input value={store.portalUrlFieldValue} disabled />
                </FormFieldLine>

                <Button
                    onClick={() => store.activate()}
                    text="Activate"
                    hasLoader={true}
                    isLoading={store.isProcessing}
                    disabled={store.isProcessing || !store.canSubmitActivation}
                />

                {store.showSuccess && (
                    <div className="results-message">
                        <FontBody1 color={FONT_COLOR.SEMANTIC_SUCCESS}>
                            Successfully activated
                        </FontBody1>
                    </div>
                )}

                {store.errorMessage && (
                    <div className="results-message">
                        <FontBody1 color={FONT_COLOR.SEMANTIC_DANGER}>
                            {store.errorMessage}
                        </FontBody1>
                    </div>
                )}
            </ListLayout>
        </Card>
    );
});

export default ActivateGlobaleStoreCard;
